import { createSlice } from '@reduxjs/toolkit';

const statusSlice = createSlice({
    name: 'status',
    initialState: {
        term: '',
    },
    reducers: {
        UpdateStatusTerm: (state, action) => {
            state.term = action.payload;
        },
    },
});

export const { UpdateStatusTerm } = statusSlice.actions;
export default statusSlice.reducer;
